export const ConvType = {
  AwaitingFunds: 'awaiting_funds',
  CompliancePending: 'send_compliance_pending',
  FundsReceived: 'funds_received',
};
